export default __webpack_public_path__ + "static/imgNine-16d897a9eda09f1944330a13aa41f5a2.jpg";